/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Kind_DmgInputs */

const en_fc_dl_kind_dmg = /** @type {(inputs: Fc_Dl_Kind_DmgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DMG installer`)
};

/**
* | output |
* | --- |
* | "DMG installer" |
*
* @param {Fc_Dl_Kind_DmgInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_kind_dmg = /** @type {((inputs?: Fc_Dl_Kind_DmgInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Kind_DmgInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_kind_dmg(inputs)
});
export { fc_dl_kind_dmg as "fc.dl.kind.dmg" }